import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import api from "../../../../store/api";
import { AppThunk } from "../../../../store/app";
import Config from "../../../../config/Config";
import { dateCompare } from "../../../../config/Global";
import { apiUrls } from "./apiUrls";

interface InitialState {
    isLoading: boolean;
    agGrid: any;
    rowData: any;
    perPage: any;
    details: any;
    exportId: any;
}

const initialState = {
    isLoading: false,
    agGrid: null,
    rowData: null,

    perPage: Config.grid.server.gridOptions?.paginationPageSize,
    details: null,
    exportId: null
} as InitialState;

const IndustrySlice = createSlice({
    name: "industry",
    initialState,
    reducers: {
        start: state => {
            state.isLoading = true;
        },
        success: state => {
            state.isLoading = false;
        },
        failure: state => {
            state.isLoading = false;
        },
        setGrid: (state, action: PayloadAction<any>) => {
            state.agGrid = action?.payload;
        },
        setRowData: (state, action: PayloadAction<any>) => {
            state.rowData = action?.payload;
        },
        setPerPage: (state, action: PayloadAction<any>) => {
            state.perPage = action?.payload;
            if (state.agGrid) {
                state.agGrid.api.paginationSetPageSize(Number(state.perPage));
                state.agGrid.api.setCacheBlockSize(state.perPage);
            }
        },
        setDetails: (state, action: PayloadAction<any>) => {
            state.details = action?.payload;
        },
    },
});

export const {
    start,
    success,
    failure,
    setRowData,
    setGrid,
    setPerPage,
    setDetails,
} = IndustrySlice.actions;

/** For Listing:Start */
export const fetchList =
    (): AppThunk<any> =>
        async dispatch => {
            try {
                dispatch(start());
                dispatch(setRowData([]));
                const response = await api.get(apiUrls.list);
             
                dispatch(setRowData(response.data.rows));
                dispatch(success());
                return Promise.resolve(response.data);
            } catch (error: any) {
                dispatch(failure());
                return Promise.reject(error.data);
            }
        };
/** For Listing:End */

export const setPerPageSize =
    (size: number): AppThunk<any> =>
        async dispatch => {
            dispatch(setPerPage(size));
            dispatch(fetchList());
        };

//** For curd operations:Start */
export const createRecord =
    (action: any): AppThunk<any> =>
        async dispatch => {
            try {
                dispatch(start());
                const response = await api.post(apiUrls.create, action);
                dispatch(success(response.data));
                dispatch(fetchList());
                return Promise.resolve(response.data);
            } catch (error: any) {
                dispatch(failure(error.data));
                return Promise.reject(error.data);
            }
        };

export const updateRecord =
    (id: number, action: any): AppThunk<any> =>
        async dispatch => {
            try {
                dispatch(start());
                const response = await api.post(apiUrls.update(id), action);
                dispatch(success(response.data));
                dispatch(fetchList());
                return Promise.resolve(response.data);
            } catch (error: any) {
                dispatch(failure(error.data));
                return Promise.reject(error.data);
            }
        };


export const deleteRecord =
    (id: number, action: any): AppThunk<any> =>
        async dispatch => {
            try {
                dispatch(start());
                const response = await api.delete(apiUrls.delete(id), action);
                dispatch(success(response.data));
                dispatch(fetchList());
                return Promise.resolve(response.data);
            } catch (error: any) {
                dispatch(failure(error.data));
                return Promise.reject(error.data);
            }
        };


export const details =
    (id: number): AppThunk<any> =>
        async dispatch => {
            try {
                const response = await api.get(apiUrls.details(id));
                var modifiedData = response.data.data;
                modifiedData.is_completed = dateCompare(modifiedData.end_date) != 1 ? 'Completed' : 'Running';
                dispatch(setDetails(modifiedData));
                return Promise.resolve(response.data);
            } catch (error: any) {
                return Promise.reject(error.data);
            }
        };

export const changeStatus =
    (id: number, status: number): AppThunk<any> =>
        async dispatch => {
            try {
                const response = await api.post(apiUrls.changeStatus(id), { status });
                dispatch(fetchList());
                return Promise.resolve(response.data);
            } catch (error: any) {
                return Promise.reject(error.data);
            }
        };



export const fetchIndustryList =
    (): AppThunk<any> =>
        async dispatch => {
            try {
                const response = await api.get(apiUrls.list);
                return Promise.resolve(response.data);
            } catch (error: any) {
                return Promise.reject(error.data);
            }
        };

export const fetchIndustryWizeData =
    (industry_id: number[], filter: number[]): AppThunk<any> =>
        async () => {
            try {
                const requestdata = {
                    industry_id: industry_id,
                    filter: filter
                }
                const response = await api.post(apiUrls.getIndustryWizeData, requestdata);
                return Promise.resolve(response.data);
            } catch (error: any) {
                return Promise.reject(error.data);
            }
        };

export const fetchIndustryCategoryList =
    (): AppThunk<any> =>
        async dispatch => {
            try {
                const response = await api.get(apiUrls.categoryList);
                return Promise.resolve(response.data);
            } catch (error: any) {
                return Promise.reject(error.data);
            }
        };





const industryReducer = IndustrySlice.reducer;
export default industryReducer;
